<template>
  <div v-if="showOptions" class="options-popup" :style="{ top: position.y + 'px', left: position.x + 'px' }">
    <div class="options-list">
      <div v-for="(option, index) in options" :key="option.id" class="option-item" @click="selectOption(option,index)">
        {{ option.name }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'options-popup',
    props: {
      options: {
        type: Array,
        required: true
      },
      showOptions: {
        type: Boolean,
        required: true
      },
      position: {
        type: Object,
        required: true
      }
    },
    methods: {
      selectOption(option, index) {
        // Emit an event or perform an action when an option is selected
        console.log('Selected option:', option);
        this.$parent.selectOption(index);
      }
    }
  };
</script>

<style scoped>
  .options-popup {
    position: absolute;
    z-index: 1000; /* Ensure it's above other content */
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    max-height: 150px; /* Limit height to ensure it doesn't cover entire screen */
    overflow-y: auto; /* Enable vertical scrolling if necessary */
  }

  .options-list {
    padding: 10px;
  }

  .option-item {
    padding: 5px 10px;
    cursor: pointer;
  }

    .option-item:hover {
      background-color: #f0f0f0;
    }
</style>



// WEBPACK FOOTER //
// src/components/discuss/options-popup.vue